import SPlus3ErrorDialog from "../../../features/errors/SPlus3ErrorDialog";
import { useAppSelector } from "../../../hooks";

const ErrorDialogSwitcher: React.FC<{}> = () => {
    const errorState = useAppSelector(state => state.error)
    if (errorState.lastError != null) {
        return <SPlus3ErrorDialog lastError={errorState.lastError} />
    } else {
        return null;
    }
}

export default ErrorDialogSwitcher;